define('views/blocks/OrderTrackingView',['app','hooks','underscore', 'jquery', 'backbone', 'router',
        'InternalLinkView',
        'SubView',
        'template!blocks/order-tracking',
        'models/OrderModel',
    ], function (app, hooks, _, $, Backbone, router,
         InternalLinkView,
         SubView,
         OrderTrackingTemplate,
         OrderModel
    )
    {

        return Backbone.View.extend(SubView).extend({
            events: {
                'click .btn-close, .order-tracking--modal__overlay':'minimize',
                'click .order-tracking--modal__mini':'clickMini',
                'click .btn-submit':'goAccount'
            },
            isMaximize:false,
            isMinimize:false,

            initialize: function (options)
            {
                var view = this;
                view.subviews = [];
                view.firstMinimize = false;
                view.order = options.order;
                view.render();

                function onPageChange(pageName){
                    var firstMinimize = !!view.firstMinimize,
                        maximize = !firstMinimize, minimize = firstMinimize, toggle = true,
                        accountSidebarName = $('.account-sidebar a.active').data('name'),
                        isAccountOrders = (accountSidebarName === 'orders') || (accountSidebarName === 'dashboard'); // DOM based hack !
                    if(pageName === 'CheckoutConfirmation' || (pageName === 'Account' && isAccountOrders)){
                        toggle = maximize = minimize = false;
                    }
                    view.toggleState(maximize,minimize);
                }
                function onPageChangeWait(){
                    setTimeout(function(){
                        onPageChange('Account')
                    },0);
                }
                view.listenTo(app,'pageChange',onPageChange);
                view.listenTo(app,'changeAccountPage',onPageChangeWait);
                view.progessOrderTest();
            },

            progessOrderTest : function() {
                var view = this,
                    order = view.order;
                function onSync() {
                    if (!order.isComplete()) {
                        view.render();
                        setTimeout(function () {
                            view.progessOrderTest();
                        }, 60000);
                    }else{
                        view.remove();
                    }
                }
                order.once('sync', onSync);
                order.remoteFetch();
            },

            render:function(){
                var view = this;
                view.$el.html(OrderTrackingTemplate(view));
            },

            clickMini: function(){
                if(app.isMobile()){
                    this.goAccount();
                }else{
                    this.toggleState(true,false);
                }
            },

            minimize: function(){
                this.firstMinimize = true;
                this.toggleState(false, true);
            },

            toggleState: function(maximize,minimize){
                var view = this;
                view.isMaximize = maximize;
                view.isMInimize = minimize;
                view.$('.order-tracking')
                    .toggleClass('maximize',maximize)
                    .toggleClass('minimize',minimize);
            },

            goAccount: function(){
                app.go('accountOrders')
                this.toggleState(false,false);
            }

        });
    });
